import { logger } from 'common/services';
import { dataToFile } from 'common/utils';
import { format } from 'date-fns';

type StoredWsMessage = { path: string; payload: unknown; timestamp: number; type: 'INCOMING' | 'OUTGOING' };

export const MESSAGES_HISTORY_LIMIT = 1000;

export const SocketMessagesLogger = () => {
  const messages: StoredWsMessage[] = [];

  const captureSocketMessage = (message: Omit<StoredWsMessage, 'timestamp'>) => {
    messages.push({
      timestamp: Date.now(),
      type: message.type,
      path: message.path,
      payload: message.payload,
    });
    if (messages.length > MESSAGES_HISTORY_LIMIT) {
      messages.shift();
    }

    logger.info('WebSocket message', {
      wsType: message.type,
      wsPath: message.path,
      wsPayload: message.payload,
    });
  };

  const dumpSocketMessages = () => {
    try {
      dataToFile(
        JSON.stringify(messages, null, 2),
        `ws_messages_log_${format(new Date(), 'dd_MM_yyyy_HH_mm_ss')}.txt`,
        'text/plain'
      );
      messages.length = 0;
    } catch (error) {
      logger.error('[socketMessagesLogger] Error while dumping WS messages', {
        error,
        extra: { messagesCount: messages.length },
      });
    }
  };

  return {
    captureSocketMessage,
    dumpSocketMessages,
  };
};

export const { captureSocketMessage, dumpSocketMessages } = SocketMessagesLogger();

// this makes it possible to call this function via e.g. dev tools console
window.dumpSocketMessages = dumpSocketMessages;
